<template>
  <avs-card class="pb-4">
    <template v-slot:title>
      <v-toolbar class="mt-4 custom-toolbar bgTable" elevation="0">
        <v-text-field
          class="mr-8"
          clearable
          hide-details
          prepend-inner-icon="mdi-magnify"
          :label="$t('commons.search')"
          v-model="search"
        />

        <avs-createButton
          :spantext="
            $t('Nouveau coupon')
          "
          menu
          :name="
            $t('Nouveau coupon')
          "
          @click="handleOpenEditDialog()"
        >
        </avs-createButton>
      </v-toolbar>
    </template>
    <template v-slot:content>
      <v-data-table
        class="ma-10 bgTable"
        dense
        :headers="headers"
        :no-data-text="$t('messages.information.no_data')"
        :items="items"
        :items-per-page="-1"
        :search="search"
        item-key="id"
        @dblclick:row="
          ($event, { item }) => {
            if (allow.duplicate(item)) {
              handleOpenEditDialog(item);
            }
          }
        "
      >
        <!-- <template v-slot:item.status="{ item }">
          <avs-chip :label="false">
            {{ item.status }}
          </avs-chip>
        </template> -->
        <template #item.redeemed_at="{ item }">
          {{ toDatetime(item.redeemed_at) }}
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="d-flex justify-center">
            <!-- <avs-editButton
              @click.stop="handleOpenEditDialog(item, 1)"
              :spantext="
                $t('actions.edit', {
                  entity: $t('commons.drawer.coupon').toLowerCase(),
                })
              "
            />
            <avs-button
              icon
              color="secondary"
              :iconI="'mdi-eye'"
              label
              fab
              small
              @click.stop="handleOpenEditDialog(item, 2)"
              :spantext="
                $t('actions.open', {
                  entity: $t('commons.drawer.coupon').toLowerCase(),
                })
              "
            /> -->

            <avs-deleteButton
              @click.stop="handleOpenDeleteDialog(item)"
              :spantext="
                $t('actions.delete', { entity: $t('commons.fieldtype').toLowerCase() })
              "
            />
          </div>
        </template>
      </v-data-table>
      <!-- v-html="document.description" -->

      <v-dialog v-model="editDialogIsOpen" width="40vw">
        <component
          v-model="selectedItem"
          :hasUniqueName="hasUniqueName"
          :is="editDialogContent"
          :isEditable="isEditable"
          @cancel="handleCancel"
          @error="handleError"
          @success="handleSuccess"
        />
      </v-dialog>

      <DeleteDialog
        v-model="deleteDialogIsOpen"
        @cancel="handleCancel"
        @delete="handleDelete"
        resource="Notification"
      />
    </template>
  </avs-card>
</template>

<script>
import { toDatetime } from "@/utils/datetime";
import { CouponUsersDetailService } from "@/services";
import { mkUnique } from "@/utils/validator";

import DeleteDialog from "@/components/generics/dialogs/DeleteDialog.vue";
import CouponUserEditor from "@/components/ri3/coupon/CouponUserEditor.vue";
import { Approved, Canceled, Pending } from "@/components/generics/status";

export default {
  name: "CouponUsersDetail",
  components: { DeleteDialog, CouponUserEditor, Approved, Canceled, Pending },
  created() {
    this.fetchFieldTypes();
  },
  computed: {
    hasUniqueName: {
      get() {
        const names = this.items
          .filter((e) => e.name !== this.selectedItem?.name)
          .map((e) => e.name);
        return mkUnique(names, "name");
      },
    },
  },
  data() {
    return {
      headers: [
        {
          text: this.$t("code"),
          value: "coupon.code",
          // class: "min-width-150",
          sortable: true,
        },
        {
          text: this.$t("Pourcentage"),
          value: "coupon.discount_percentage",
          sortable: true,
          filterable: false,
        },
        {
          text: this.$t("Date d'utilisation"),
          value: "redeemed_at",
          sortable: true,
          filterable: false,
        },
        {
          text: this.$t("Utilisateur"),
          value: "user.username",
          align: "center",
          sortable: true,
          filterable: false,
        },

        {
          text: this.$t("commons.action"),
          value: "actions",
          align: "center",
          sortable: false,
          filterable: false,
        },
      ],
      isEditable: true,
      items: [],
      search: "",

      // basecomponents: Object.values(COMPONENT_ENUM),
      deleteDialogIsOpen: false,
      editDialogIsOpen: false,
      editDialogContent: null,
      selectedItem: undefined,
      confirmDialogIsOpen: false,
    };
  },
  methods: {
    toDatetime,
    fetchFieldTypes() {
      CouponUsersDetailService.getAll(this)
        .then((response) => {
          this.items = response.results	;
        })
        .catch((err) => {
          if (err.response && err.response.status === 403) {
            this.$store.commit("app/message", {
              msg: this.$t("messages.error.permission_denied"),
              color: "error",
            });
          }
        });
    },
    formatNumber(value) {
      if (!value) return "";
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },
    handleOpenConfirmDialog(item) {
      this.selectedItem = item;
      this.confirmDialogIsOpen = true;
    },
    confirmAction(action) {
      this.confirmDialogIsOpen = false;
      switch (action) {
        case "accept":
          this.authorizeRequest(this.selectedItem);
          break;
        case "reject":
          this.rejectRequest(this.selectedItem);
          break;
        case "close":
          this.send(this.$t("messages.info.operation_canceled"), "info");
          break;
        default:
          break;
      }
    },
    authorizeRequest(item) {
      CouponUsersDetailService.authorize(item.id)
        .then(() => {
          this.handleSuccess();
        })
        .catch((error) => {
          const message =
            error?.response?.data?.state || this.$t("messages.error.operation_failed");
          this.handleError(message);
        });
    },
    rejectRequest(item) {
      CouponUsersDetailService.reject(item.id)
        .then(() => {
          this.send(this.$t("messages.success.rejected"), "success");
          this.handleSuccess();
        })
        .catch((error) => {
          const message =
            error?.response?.data?.state || this.$t("messages.error.operation_failed");
          this.handleError(message);
        });
    },
    handleStatusComponent(action) {
      return action.status;
    },
    handleOpenDeleteDialog(item) {
      this.selectedItem = item;
      this.deleteDialogIsOpen = true;
    },
    handleOpenEditDialog(item, res) {
      this.selectedItem = undefined;
      this.isEditable = true;
      if (res) {
        this.selectedItem = item;
        if(res === 2){
          this.isEditable = false;
        }
        
      }
      this.handleOpenEditDialogByComponent();
    },
    handleOpenEditDialogByComponent() {
      this.editDialogIsOpen = true;
      this.editDialogContent = "CouponUserEditor";
    },
    handleCancel() {
      this.selectedItem = undefined;
      this.deleteDialogIsOpen = false;
      this.editDialogIsOpen = false;
      this.editDialogContent = null;
    },
    handleError(message) {
      this.send(message || "Enter a valid email address.", "error");
    },
    handleSuccess() {
      this.handleCancel();
      this.$nextTick(() => {
        this.fetchFieldTypes();
        this.send(this.$t("messages.success.operation"), "success");
      });
    },
    handleDelete() {
      CouponUsersDetailService.delete(this.selectedItem.id)
        .then(() => {
          this.handleSuccess();
        })
        .catch((error) => {
          const message = error?.response.data?.state;
          this.handleError(message);
        });
    },
    send(msg, color) {
      this.$store.commit("app/message", { msg, color });
    },
  },
};
</script>
